
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/modes-de-paiement",
      function () {
        return require("private-next-pages/modes-de-paiement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/modes-de-paiement"])
      });
    }
  